module.exports = __webpack_public_path__ + "img/advanced-survery-active.fe4e8cd1.svg";